export default {
    "otherRetirementPlans": [
        {
            "planName": "CERIDIAN                (804599) SAVINGS AND INVESTMENT PLAN ",
            "planNumber": "804599"
        },
        {
            "planName": "CERIDIAN                (904599) SAVINGS AND INVESTMENT PLAN ",
            "planNumber": "904599"
        },
        {
            "planName": "CERIDIAN                (104599) SAVINGS AND INVESTMENT PLAN ",
            "planNumber": "104599"
        }
    ],
    "showOldRetirementPlans": true
}